import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEFamilyOverviewCardActions = {
  initPeFamilyOverviewCard: ({ commit }) => {
    commit('setPeFamilyOverviewCardLock', true)
  },
  peFamilyOverviewCardUpdate: async ({ commit }, { id, section }) => {
    return axiosRequest.
      patch(`/parties/${id}`, {
        currently_married: section.currently_married,
        child_status: section.child_status,
        father_status: section.father_status,
        lpr_siblings: section.lpr_siblings,
        mother_status: section.mother_status,
        spouse_status: section.spouse_status,
        num_children: section.num_children,
        num_marriages: section.num_marriages,
        num_siblings: section.num_siblings,
        usc_siblings: section.usc_siblings,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeFamilyOverviewCardLock', true)
        commit('pePatchParty', {
          currently_married: updatedParty.currently_married,
          child_status: section.child_status,
          father_status: updatedParty.father_status,
          lpr_siblings: updatedParty.lpr_siblings,
          mother_status: updatedParty.mother_status,
          num_children: updatedParty.num_children,
          num_marriages: updatedParty.num_marriages,
          num_siblings: updatedParty.num_siblings,
          spouse_status: section.spouse_status,
          usc_siblings: updatedParty.usc_siblings,
        })
      }).
      catch(handleError)
  },
}

export const PEFamilyOverviewCardMutations = {
  setPeFamilyOverviewCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'FamilyOverviewCard', lock)
  },
}

export const PEFamilyOverviewCardGetters = {
  peFamilyOverviewCardLock: state => state.partyEdit.partySections.FamilyOverviewCard,
}
